import { render, staticRenderFns } from "./navLeftBar.vue?vue&type=template&id=28c7a8aa&scoped=true&"
import script from "./navLeftBar.vue?vue&type=script&lang=js&"
export * from "./navLeftBar.vue?vue&type=script&lang=js&"
import style0 from "./navLeftBar.vue?vue&type=style&index=0&id=28c7a8aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c7a8aa",
  null
  
)

export default component.exports